import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { DurationPipe } from './duration.pipe'
import { DistancePipe } from './distance.pipe'
import { VoltagePipe } from './voltage.pipe'
import { SafeStylePipe } from './safe-style.pipe'
import { FuelLevelPipe } from './fuel-level.pipe'
import { RecipientsPipe } from '@app/modules/client/shared/pipes/recipients.pipe'

@NgModule({
  declarations: [DurationPipe, DistancePipe, VoltagePipe, SafeStylePipe, FuelLevelPipe, RecipientsPipe],
  exports: [DurationPipe, DistancePipe, VoltagePipe, SafeStylePipe, FuelLevelPipe, RecipientsPipe],
  imports: [CommonModule],
})
export class PipesModule {}
